export function stripHtml(html = "") {
  if (!html) return "";
  return String(html).replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
}

export function truncate(text = "", max = 160) {
  const s = String(text || "");
  if (s.length <= max) return s;
  return s.slice(0, max - 1).trim() + "…";
}

export function safeAlt({ title, category, authorByline, author } = {}) {
  if (title) return String(title);
  const parts = [category, authorByline || author].filter(Boolean);
  return parts.length ? parts.join(" — ") : "Article image";
}

// JSON-LD helper (removes undefined/null safely)
export function jsonLd(obj) {
  const clean = JSON.parse(
    JSON.stringify(obj, (_k, v) => (v === undefined || v === null ? undefined : v))
  );
  return JSON.stringify(clean);
}

export function absoluteUrl(base, pathOrUrl) {
  try { return new URL(pathOrUrl, base).toString(); }
  catch { return pathOrUrl || base; }
}